module.exports = __webpack_public_path__ + "img/keyboard-arrow-right.7e6d9395.svg";